module.exports = __webpack_public_path__ + "static/img/icon-2.c0ee9915.svg";